module.exports = __webpack_public_path__ + "static/img/WEST-COAST.28833b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WEST-COAST.svg
// module id = lIhJ
// module chunks = 0